module.exports = __webpack_public_path__ + "static/media/galerija_2021 (7).3df4aeb2.jpg";